// useYear.js
const log = (msg) => process.env.VUE_APP_DEV && console.log(msg); // eslint-disable-line

import {useRoute} from "vue-router";
import {ref, watch} from "vue";
import history from "@/assets/history.json";

function getFallbackYear() {
  const yearKeys = Object.keys(history.years || {});
  if (!yearKeys.length) return null;
  const sorted = yearKeys.sort((a, b) => Number(b) - Number(a));
  return sorted[0];
}

function getRouteYear(route) {
  const rawYear = route.params?.year;
  if (!rawYear) return null;
  if (!/^\d{4}$/.test(rawYear)) return null;
  return rawYear;
}

function getInitialYear(route) {
  const routeYear = getRouteYear(route);
  if (routeYear) return routeYear;
  return getFallbackYear();
}

function updateYearAndTimeZone(route, year, timeZone) {
  const routeYear = getRouteYear(route);
  const resolvedYear = routeYear || getFallbackYear();
  year.value = resolvedYear;
  timeZone.value = resolvedYear ? history.years[resolvedYear] : "test";
  log(`selectedYear: ${resolvedYear}`);
}

export function useSelectedYear() {
  const route = useRoute();
  const initialYear = getInitialYear(route);
  const year = ref(initialYear);
  const timeZone = ref(initialYear ? history.years[initialYear] : "test");
  log(`selectedYear: initially = ${initialYear}`);
  watch(
    () => route.params.year,
    () => updateYearAndTimeZone(route, year, timeZone),
    {immediate: false}
  );
  return [year, timeZone];
}
